module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Ver planillas\" ng-click=\"$ctrl.verSupervisiones()\">\n  <i class=\"fa fa-list\"></i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reg-proyectos/bandeja/supervisiones/supervisiones.html
// module id = 798
// module chunks = 0